module.exports = __webpack_public_path__ + "static/media/blue-spinner.c8b43485.svg";